import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './WithdrawalEmailTransfer.css';

// Mock asset data
const mockAsset = {
  symbol: 'BTC',
  name: 'Bitcoin',
  icon: '₿',
  color: '#f7931a',
  minAmount: 2,
  maxAmount: 0.00024
};

const WithdrawalEmailTransfer: React.FC = () => {
  const navigate = useNavigate();
  const [amount, setAmount] = useState('1');
  const [email, setEmail] = useState('hashlet.official@gmail.com');

  const handleBack = () => {
    navigate(-1);
  };

  const handleRequestOTP = () => {
    navigate('/withdrawal-confirm-withdrawal');
  };

  return (
    <div className="email-transfer-container">
      {/* Header */}
      <header className="email-transfer-header">
        <button className="email-transfer-back-btn" onClick={handleBack} aria-label="Go back">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>

        <div className="email-transfer-header-actions">
          <button className="email-transfer-header-btn">
            <span className="email-transfer-header-btn-icon">+</span>
            <span>Buy Crypto</span>
          </button>
          <button className="email-transfer-header-btn">
            <svg width="11" height="11" viewBox="0 0 11 11" fill="none">
              <circle cx="5.5" cy="5.5" r="4.5" stroke="currentColor" strokeWidth="1.5"/>
              <path d="M5.5 3V5.5L7 7" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <span>History</span>
          </button>
        </div>
      </header>

      {/* Content */}
      <div className="email-transfer-content">
        {/* Title */}
        <h1 className="email-transfer-title">Email Transfer</h1>

        {/* Asset Section */}
        <div className="email-transfer-section">
          <label className="email-transfer-label">Asset</label>
          <button className="email-transfer-asset-selector">
            <div className="email-transfer-asset-info">
              <div
                className="email-transfer-asset-icon"
                style={{ backgroundColor: mockAsset.color }}
              >
                {mockAsset.icon}
              </div>
              <span className="email-transfer-asset-symbol">{mockAsset.symbol}</span>
            </div>
            <svg className="email-transfer-asset-chevron" width="20" height="20" viewBox="0 0 20 20" fill="none">
              <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>

        {/* Amount Section */}
        <div className="email-transfer-section">
          <label className="email-transfer-label">Amount</label>
          <div className="email-transfer-amount-container">
            <input
              type="text"
              className="email-transfer-amount-input"
              value={amount}
              onChange={(e) => setAmount(e.target.value)}
              placeholder="0"
            />
            <span className="email-transfer-amount-suffix">{mockAsset.symbol}</span>
          </div>
          <div className="email-transfer-limits">
            <span className="email-transfer-limit">
              Minimum: <span className="email-transfer-limit-value">{mockAsset.minAmount} {mockAsset.symbol}</span>
            </span>
            <span className="email-transfer-limit">
              Maximum: <span className="email-transfer-limit-max">{mockAsset.maxAmount} {mockAsset.symbol}</span>
            </span>
          </div>
        </div>

        {/* Email Section */}
        <div className="email-transfer-section">
          <label className="email-transfer-label">Email</label>
          <input
            type="email"
            className="email-transfer-email-input"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter recipient email"
          />
        </div>

        {/* Submit Button */}
        <button
          className="email-transfer-submit-btn"
          onClick={handleRequestOTP}
        >
          Request OTP
        </button>
      </div>
    </div>
  );
};

export default WithdrawalEmailTransfer;
